// course/vm-view
import { useListIds } from 'src/hooks/use-list-table';
import { useListSearch } from 'src/hooks/use-list-search';
import { useItemsStore } from 'src/hooks/use-items-store';

import { getList, getMyItem } from './data-view';

export const useItemsSearch = () => {
  return useListSearch();
};
export const useItemsIds = () => {
  return useListIds();
};

class CourseApi {

  getItems(searchState, enumType) {
    return useItemsStore(searchState, getList, {enumType: 'with_degree'});
  }

  getDetail(payload, onSuccess) {
    getMyItem(payload).then((result) => {
      onSuccess(result);
    });
  }

}

export const courseApi = new CourseApi();